export default __webpack_public_path__ + "static/media/mail.2c04c4bd.svg";